export default Object.freeze({
  Active: 1,
  Closed: 2,
  Blocked: 3,
});
